import { initGraphQLTada } from 'gql.tada'
import type { introspection } from './graphql-env.d.ts'

export const gql = initGraphQLTada<{
  introspection: introspection
  scalars: {
    numeric: number
    timestamp: string
    timestamptz: string
    jsonb: Record<string, any>
  }
}>()

export type { FragmentOf, ResultOf, VariablesOf } from 'gql.tada'
export { readFragment } from 'gql.tada'
